if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (str) {
        return this.indexOf(str) === 0;
    };
}

/**
 * String.prototype.replaceAll() polyfill
 * https://gomakethings.com/how-to-replace-a-section-of-a-string-with-another-one-with-vanilla-js/
 * @author Chris Ferdinandi
 * @license MIT
 */
if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function (str, newStr) {
        // If a regex pattern
        if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
            return this.replace(str, newStr);
        }

        // If a string
        return this.replace(new RegExp(str, 'g'), newStr);
    };
}

window.B.Util = {
    setOnError: function () {
        window.onerror = function (msg, url, line, colno, error) {
            B.Util.processJsException(location.pathname, msg, url, line, colno, error);
            return false;
        };
    },
    processJsException: function (pathname, msg, url, line, colno, error) {
        try {
            B.Util.ajax({
                url: B.Config.apiUrl + '/v1/jsException',
                method: 'POST',
                data: {
                    pathname: pathname,
                    msg: msg,
                    url: url,
                    line: line,
                    colno: colno
                },
                error: function () {
                    return true;
                }
            });

            try {
                if (typeof Sentry !== 'undefined') {
                    Sentry.captureException(error);
                }
            } catch (e) {
            }
        } catch (e) {
        }
    },
    ajax: function (options) {
        var defaultOptions = {
            type: 'post',
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            }
        };

        var firstOptions = jQuery.extend(defaultOptions, options);

        firstOptions.method = firstOptions.method || firstOptions.type;

        if (typeof firstOptions.type === 'undefined' || firstOptions.type.toLowerCase() != 'get') {
            var csrfToken = jQuery('meta[name=secureToken]').attr('value');

            var csrfFunc = function (request) {
                request.setRequestHeader('X-CSRF-TOKEN', csrfToken);
            };

            firstOptions.beforeSend = csrfFunc;
        }

        var id = new Date().getTime();

        if (B.UserAgent.isIE11Under) {
            B.Util.alert('지원되지 않는 브라우저입니다.\n최신 브라우저를 사용해주세요.\n(IE11+, Chrome, Firefox, Safari)');
            return;
        }

        var successFunction = firstOptions.success;
        var errorFunction = firstOptions.error;

        jQuery.ajax(jQuery.extend(firstOptions, {
            success: function (data, textStatus, jqXHR) {
                if (data.code === 200) {
                    if (B.isDebug()) {
                        var gid = '[' + firstOptions.method + '][' + (new Date().getTime() - id) + 'ms]' + firstOptions.url;
                        console.groupCollapsed(gid);
                        console.log(id, 'SUCCESS', data);
                        console.groupEnd(gid);
                    }

                    if (successFunction) successFunction.apply(null, arguments);
                } else {
                    this.error(jqXHR, textStatus);
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (B.isDebug()) {
                    var gid = firstOptions.url;
                    console.groupCollapsed(gid);
                    console.error(textStatus, errorThrown);
                    console.error(jqXHR.responseJSON);
                    console.groupEnd(gid);
                }

                B.Util.processErrorMessage(jqXHR, errorFunction);
            }
        }));
    },

    processErrorMessage: function (xhr, errorFunction) {
        if (errorFunction) {
            var stop = errorFunction(xhr);

            if (stop) {
                return;
            }
        }

        if (B.Util.processSignin(xhr)) {
            return;
        }

        if (B.Util.processRedirect(xhr)) {
            return;
        }

        var json = B.Util.getJson(xhr);

        if (json) {
            var errorMessage = B.Util.getErrorMessage(json);

            if (errorMessage != null) {
                alert(errorMessage);
            }
        }
    },

    /**
     * requestMapping: /v1/@@{userId}/{articleNo}/comment/{commentNo}
     * parameter: {
     *     userId: 'x',
     *     articleNo: 2,
     *     commentNo: 3
     * }
     *
     * -> v1/@@x/2/comment/3
     * @param requestMapping
     * @param parameter
     */
    createUrl: function (requestMapping, parameter) {
        if (!requestMapping) {
            return null;
        }

        if (!parameter) {
            return requestMapping;
        }

        if (!jQuery.isPlainObject(parameter)) {
            return requestMapping;
        }

        var keyList = Object.keys(parameter);


        for (var i = 0; i < keyList.length; i++) {
            var key = keyList[i];
            var value = parameter[key];

            requestMapping = requestMapping.replaceAll('{' + key + '}', value);
        }

        return requestMapping;
    },

    getJson: function (xhr) {
        return (xhr.responseJSON || xhr.responseText) || xhr;
    },

    getCode: function (result) {
        return result.code || result.status;
    },

    processSignin: function (xhr) {
        var json = B.Util.getJson(xhr);

        if (json) {
            var code = json.code;

            if (code) {
                if (code === 401 || code === 605) {
                    B.Util.signin(window.location.href);
                    return true;
                }
            }
        }

        return false;
    },

    processRedirect: function (xhr) {
        var json = B.Util.getJson(xhr);

        if (json) {
            if (json.redirectUrl) {
                alert(json.desc);

                if (json.redirectUrl === 'close') {
                    window.self.close();
                } else if (json.redirectUrl === 'none') {
                    // 아무런 행위를 하지 않는다.
                } else {
                    location.href = json.redirectUrl;
                }

                return true;
            }
        }

        return false;
    },

    greaterThanVersion1: function (result) {
        if (result) {
            return B.Util.greaterThanVersion1FromJson(result.responseJSON);
        }

        return false;
    },

    greaterThanVersion1FromJson: function (json) {
        if (json) {
            var version = json.version || 1;
            return version > 1;
        }

        return false;
    },

    getErrorMessage: function (json) {
        if (!json) {
            return null;
        }

        if (!B.Util.greaterThanVersion1FromJson(json)) {
            return null;
        }

        return B.Util.getErrorMessageWithTileAndDesc(json.title, json.desc);
    },

    getErrorMessageWithTileAndDesc: function (title, desc) {
        title = title || '';
        desc = desc || '';

        title = B.Util.trim(title);
        desc = B.Util.trim(desc);

        var errorMessage = '오류가 발생하였습니다.\n잠시 후에 다시 시도해보세요.';

        if (title !== '' && desc === '') {
            errorMessage = title;
        } else if (title === '' && desc !== '') {
            errorMessage = desc;
        } else if (title !== '' && desc !== '') {
            errorMessage = title + '\n' + desc;
        }

        return errorMessage;
    },

    ajaxCommonError: function (r) {
        var code = r.code || r.status;

        if (code != 401 && code != 605) {
            alert('오류가 발생했습니다.');
        }

        return true;
    },

    signin: function (callbackUrl) {
        if (window.qunitContext) {
            var url = '/signin' + (callbackUrl ? '?url=' + encodeURIComponent(callbackUrl) : '');
            qunitContext.href = url;
            return;
        }

        B.Util.requireSignin(callbackUrl);
    },

    requireSignin: function (callbackUrl) {
        if (window.qunitContext) {
            qunitContext.href = url;
            return;
        }

        B.Login.proceedSignin(!B.UserAgent.isMobile, callbackUrl);
    },

    escapeHTML: function (str) {
        return jQuery('<div>').text(str).html();
    },

    setTimeoutForT: function (fnc, time, scorp) {
        return window.setTimeout(jQuery.proxy(fnc, scorp), time);
    },

    setIntervalForT: function (fnc, time, scorp) {
        return window.setInterval(jQuery.proxy(fnc, scorp), time);
    },

    getTemplate: function (name, data) {
        if (Handlebars.template && B.Templates && B.Templates[name]) {
            return B.Templates[name](data);
        }
    },

    registerDefaultHelperForHandlebars: function () {
        Handlebars.registerHelper('brunchDate', function (timestamp, options) {
            if (timestamp) {
                return B.Util.brunchDate(timestamp);
            }
        });

        Handlebars.registerHelper('cutDescription', function (description) {
            return description.substring(0, _CONTENT_SUMMARY_LIMIT);
        });

        Handlebars.registerHelper('numberFormat', function (num) {
            if (!isNaN(num)) {
                return B.Util.numberFormat(num);
            }

            return num;
        });
    },

    isScrollBottomed: function () {
        var top;

        if (document.body.scrollTop === 0) {
            top = document.documentElement.scrollTop;
        } else {
            top = document.body.scrollTop;
        }

        top = Math.round(top);

        // 글꼴 크기가 100%가 아닌 경우 각 수치가 조금씩 달라지면서
        // 1px 내외의 오차가 발생하기 때문에, 안전하게 10px 정도 여유를 두고 계산.
        var height = window.innerHeight || jQuery(window).height();
        return (height + top) >= jQuery(document).height() - 10;
    },

    brunchDate: function (timestamp) {
        var MESSAGES = {
            now: function () {
                return '방금';
            },
            minutes: function (diff) {
                return Math.floor(diff / 60) + '분전';
            },
            hours: function (diff) {
                return Math.floor(diff / 3600) + '시간전';
            },
            date: function (timestamp) {
                var time = new Date(timestamp);
                return B.Util.dateFormat(time, 'N dd. yyyy');
            }
        };

        var nowTimestamp = (new Date()).getTime();
        var diff = (nowTimestamp - timestamp) / 1000;

        return diff < 60 && MESSAGES.now()
            || diff < 3600 && MESSAGES.minutes(diff)
            || diff < 34560 && MESSAGES.hours(diff)
            || MESSAGES.date(timestamp);
    },

    layer: {
        layerBaseId: 'brunchLayerBase',

        showLayerBase: function () {
            var $layerBase = jQuery('#' + this.layerBaseId);
            jQuery(document.body).addClass('of_h');

            if (!$layerBase[0]) {
                $layerBase = jQuery('<div class="brunch_layer" id=' + this.layerBaseId + '><\/div>');
                jQuery('body').append($layerBase);
            } else {
                $layerBase.show();
            }

            return $layerBase;
        },

        hideLayerBase: function () {
            jQuery(document.body).removeClass('of_h');
            return jQuery('#' + this.layerBaseId).hide();
        }
    },

    dateFormat: (function () {
        var MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        var formatFunc = function (format) {
            var o = {
                'M+': this.getMonth() + 1,
                'd+': this.getDate(),
                'h+': this.getHours(),
                'm+': this.getMinutes(),
                's+': this.getSeconds(),
                'q+': Math.floor((this.getMonth() + 3) / 3),
                S: this.getMilliseconds(),
                N: MONTH_NAMES[this.getMonth()]
            };

            if (/(y+)/.test(format)) format = format.replace(RegExp.$1,
                (this.getFullYear() + '').substr(4 - RegExp.$1.length));

            for (var k in o) if (new RegExp('(' + k + ')').test(format)) format = format.replace(RegExp.$1,
                RegExp.$1.length == 1 ? o[k]
                    : ('00' + o[k]).substr(('' + o[k]).length));
            return format;
        };

        return function (date, format) {
            return formatFunc.call(date, format);
        };
    }()),

    alert: function (msg) {
        alert(msg);
    },

    confirm: function (str, callback) {
        var callback = callback || function (isOk) {};

        if (confirm(str)) {
            callback(true);
        } else {
            callback(false);
        }
    },

    formatPercent: function (num, toFixed) {
        toFixed = isNaN(toFixed) ? -1 : toFixed;
        var operand = Math.pow(10, toFixed + 2);
        var temp = Math.round(num * operand) / operand;

        return temp.toFixed(toFixed);
    },

    numberFormat: function (number, x) {
        var re = '\\d(?=(\\d{' + (x || 3) + '})+$)';
        return (number + '').replace(new RegExp(re, 'g'), '$&,');
    },

    numberCutFormat: function (number) {
        var formattedNumber = number + '';

        if (number >= 10000) {
            formattedNumber = Math.round(number / 1000) + '';
            formattedNumber = formattedNumber.replace(/(\d+)(\d)/, '$1.$2만').replace(/\.0/g, '');
            return formattedNumber;
        } else if (number > 0 && number < 10000) {
            return B.Util.numberFormat(number);
        } else if (number == 0) {
            return '';
        }

        return formattedNumber;
    },

    hangulToJaso: function (text) {
        var ChoSeong = [
            0x3131, 0x3132, 0x3134, 0x3137, 0x3138, 0x3139,
            0x3141, 0x3142, 0x3143, 0x3145, 0x3146, 0x3147,
            0x3148, 0x3149, 0x314a, 0x314b, 0x314c, 0x314d, 0x314e
        ];
        var JungSeong = [
            0x314f, 0x3150, 0x3151, 0x3152, 0x3153, 0x3154,
            0x3155, 0x3156, 0x3157, 0x3158, 0x3159, 0x315a,
            0x315b, 0x315c, 0x315d, 0x315e, 0x315f, 0x3160,
            0x3161, 0x3162, 0x3163
        ];
        var JongSeong = [
            0x0000, 0x3131, 0x3132, 0x3133, 0x3134, 0x3135,
            0x3136, 0x3137, 0x3139, 0x313a, 0x313b, 0x313c,
            0x313d, 0x313e, 0x313f, 0x3140, 0x3141, 0x3142,
            0x3144, 0x3145, 0x3146, 0x3147, 0x3148, 0x314a,
            0x314b, 0x314c, 0x314d, 0x314e
        ];

        var chars = [];
        var v = [];

        for (var i = 0; i < text.length; i++) {
            chars[i] = text.charCodeAt(i);

            if (chars[i] >= 0xAC00 && chars[i] <= 0xD7A3) {
                var i1;
                var i2;
                var i3;
                i3 = chars[i] - 0xAC00;
                i1 = i3 / (21 * 28);
                i3 = i3 % (21 * 28);
                i2 = i3 / 28;
                i3 = i3 % 28;
                v.push(String.fromCharCode(ChoSeong[parseInt(i1)]));
                v.push(String.fromCharCode(JungSeong[parseInt(i2)]));

                if (i3 != 0x0000) {
                    v.push(String.fromCharCode(JongSeong[parseInt(i3)]));
                }
            } else {
                v.push(String.fromCharCode(chars[i]));
            }
        }
        return v.join('');
    },

    isKorean: function (str) {
        return /^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣].+$/.test(str);
    },

    compareToAsc: function (a, b) {
        if (a < b) {
            return -1;
        } else if (a > b) {
            return 1;
        }

        return 0;
    },

    // 한글 우선 오름차순 정렬
    compareToKoreanFirst: function (a, b) {
        function addOrderPrefix (str) {
            if (B.Util.isKorean(str)) {
                return '1' + str;
            } else {
                return '2' + str;
            }
        }

        var str1 = addOrderPrefix(a.userName.toLowerCase());
        var str2 = addOrderPrefix(b.userName.toLowerCase());

        return B.Util.compareToAsc(str1, str2);
    },

    trim: function (str) {
        if (!str) {
            return str;
        }

        if (str.trim) {
            return str.trim();
        } else {
            return $.trim(str);
        }
    },

    smoothScroll: function (anchor, padding) {
        return (function ($) {
            if (anchor && anchor.hash) {
                var target = $(anchor.hash);
                var top;
                target = target.length ? target : $('[name=' + anchor.hash.slice(1) + ']');

                if (target.length) {
                    top = target.offset().top;

                    if (padding) {
                        top -= padding;
                    }

                    $('html,body').animate({
                        scrollTop: top
                    }, 500);
                    return false;
                }
            }
        })(jQuery);
    },

    zeroPad: function (number, width) {
        if (isNaN(number)) return number;

        var n = number + '';
        return n.length > width ? number : new Array(width - n.length + 1).join('0') + n;
    },

    getWeekday: function (date) {
        var weekdays = ['일', '월', '화', '수', '목', '금', '토'];
        return weekdays[date.getDay()];
    },

    // 소셜 쉐어 버튼의 data-serviceName atrribute만 추가 하면 링크생성후 팝업 띄워줌
    socialShare: {
        builder: {
            twitter: {
                hash: function () {
                    return encodeURIComponent('브런치');
                },
                text: function (text) {
                    return encodeURIComponent(text);
                }
            }
        },
        services: {
            twitter: {
                url: 'https://twitter.com/intent/tweet',
                param: 'url',
                prefix: jQuery('#articleShareTitle').val()
            },
            facebook: {
                url: 'https://www.facebook.com/dialog/share',
                // data-articleno 속성이 있는 경우에는 dialog/feed 사용. 현재는 사용하고 있지 않음.
                urlOption: 'https://www.facebook.com/dialog/feed',
                param: 'href',
                paramOption: 'link',
                options: function (articleNo) { // 페이스북 댓글 기능이 삭제되면서 redirect_uri (SocialShareCallbackController:/callback/share/facebook) 삭제
                    return '&display=popup&app_id=313683402170826';
                },
                sharerUrl: 'https://www.facebook.com/sharer/sharer.php?u='
            },
            kakaostory: {
                url: 'https://story.kakao.com/share',
                param: 'url'
            },
            talkprofile: {
                url: B.Config.apiUrl + '/v1/social/talkprofile/post'
            },
            kakaotalk: {
                makeContext: function (e) {
                    var $target = jQuery(e.currentTarget);
                    var defaulteImage = {
                        src: 'https://t1.daumcdn.net/brunch/static/img/help/pc/img_share_default_800.png',
                        width: 800,
                        height: 400
                    };
                    var targetImage = $target.data('image');
                    var context = {
                        prefix: $target.data('prefix'),
                        description: $target.data('description'),
                        link: $target.data('link'),
                        appContext: $target.data('appcontext'),
                        image: (targetImage == '') ? defaulteImage : targetImage
                    };

                    var listContents = $target.data('list');

                    if (typeof listContents !== 'undefined' && listContents != '') {
                        context.objectType = 'list';
                        context.listContents = listContents;
                        context.headerImageUrl = $target.data('header-image');
                        context.headerTitle = $target.data('header-title');
                    }

                    return context;
                }
            }
        },
        popupSize: {
            w: 600,
            h: 400
        },
        share: function (e, extra) {
            var serviceName = jQuery(e.target).data('servicename') || jQuery(e.currentTarget).data('servicename');
            var service = this.services[serviceName];

            if (!serviceName || !service) {
                return false;
            }

            var articleUrl = window.location.href.split('#')[0];
            var articleNo = jQuery(e.target).data('articleno') || jQuery(e.currentTarget).data('articleno') || '';
            var text = jQuery(e.target).data('text') || jQuery(e.currentTarget).data('text') || service.prefix;
            var options = '';

            var targetUrl = jQuery(e.target).data('targeturl') || jQuery(e.currentTarget).data('targeturl');

            if (targetUrl) {
                articleUrl = targetUrl;
            }

            if (service.options) {
                options = service.options(articleNo, text);
            }

            var serviceUrl = service.url;
            var serviceParam = service.param;

            if (serviceName == 'facebook' && service.options && articleNo) {
                serviceUrl = service.urlOption;
                serviceParam = service.paramOption;
            }

            var popupSize = this.popupSize;
            var popupWidth = popupSize.w;
            var popupHeight = popupSize.h;
            var url = '';
            var hashTags = extra && extra.hashTags;
            var prefix = extra && extra.prefix;

            switch (serviceName) {
                case 'talkprofile':
                    B.Util.ajax({
                        url: serviceUrl,
                        type: 'POST',
                        data: {
                            articleNo: articleNo
                        },
                        success: function (r) {
                            alert('공유했습니다!\n브런치 계정과 연결된 [카카오톡 앱] > [프로필 홈]에서 공유한 글을 확인하실 수 있습니다.');
                        },
                        error: function (r) {
                            alert('일시적 문제로 공유되지 않았습니다.\n잠시 후 다시 시도해 주세요.');
                        }
                    });
                    break;
                case 'kakaotalk':
                    try {
                        console.log('util');
                        Kakao.init(B.Config.kakaoJSKey);
                    } catch (e) {
                        console.error(e);
                    }

                    var context = this.services.kakaotalk.makeContext(e);
                    var kakaoLinkData = B.getKakaoLinkData(context);
                    Kakao.Link.sendDefault(kakaoLinkData);
                    break;
                case 'facebook':
                    url = service.sharerUrl + encodeURIComponent(articleUrl);
                    window.open(url, '_blank', 'width=' + popupWidth + ', height=' + popupHeight + ',resizable=yes,scrollbars=yes');
                    break;
                case 'twitter':
                    url = serviceUrl + '?' + serviceParam + '=' + encodeURIComponent(articleUrl);

                    if (prefix) {
                        url += '&text=' + prefix;
                    }

                    if (hashTags) {
                        url += '&hashtags=' + hashTags;
                    }

                    window.open(url, service, 'width=' + popupWidth + ', height=' + popupHeight + ',resizable=yes,scrollbars=yes');
                    break;
                case 'kakaostory':
                    url = serviceUrl + '?' + serviceParam + '=' + encodeURIComponent(articleUrl);

                    if (prefix) {
                        url += '&text=' + prefix;
                    }

                    if (hashTags) {
                        var hash = encodeURIComponent('#');
                        var blank = encodeURIComponent(' ');
                        var hashTagList = hashTags.split(',');
                        var hashTagString = ' ';
                        for (var i = 0, len = hashTagList.length; i < len; i++) {
                            hashTagString += hash + hashTagList[i] + blank;
                        }
                        url += hashTagString;
                    }

                    window.open(url, service, 'width=' + popupWidth + ', height=' + popupHeight + ',resizable=yes,scrollbars=yes');
                    break;
            }
        }
    },

    bezier: function (x1, y1, x2, y2, epsilon) {
        var curveX = function (t) {
            var v = 1 - t;
            return 3 * v * v * t * x1 + 3 * v * t * t * x2 + t * t * t;
        };

        var curveY = function (t) {
            var v = 1 - t;
            return 3 * v * v * t * y1 + 3 * v * t * t * y2 + t * t * t;
        };

        var derivativeCurveX = function (t) {
            var v = 1 - t;
            return 3 * (2 * (t - 1) * t + v * v) * x1 + 3 * (-t * t * t + 2 * v * t) * x2;
        };

        return function (t) {
            var x = t;
            var t0;
            var t1;
            var t2;
            var x2;
            var d2;
            var i;

            for (t2 = x, i = 0; i < 8; i++) {
                x2 = curveX(t2) - x;

                if (Math.abs(x2) < epsilon) return curveY(t2);

                d2 = derivativeCurveX(t2);

                if (Math.abs(d2) < 1e-6) break;

                t2 = t2 - x2 / d2;
            }

            t0 = 0, t1 = 1, t2 = x;

            if (t2 < t0) return curveY(t0);

            if (t2 > t1) return curveY(t1);

            while (t0 < t1) {
                x2 = curveX(t2);

                if (Math.abs(x2 - x) < epsilon) return curveY(t2);

                if (x > x2) t0 = t2;
                else t1 = t2;

                t2 = (t1 - t0) * 0.5 + t0;
            }

            return curveY(t2);
        };
    },

    localStorage: {
        isEnable: function () {
            if (window.localStorage && window.localStorage.getItem) {
                return true;
            } else {
                return false;
            }
        },

        set: function (key, value) {
            if (window.localStorage && window.localStorage.setItem) {
                try {
                    return window.localStorage.setItem(key, value);
                } catch (e) {
                    if (B.Util.isStorageQuotaExceeded(e)) {
                        // quota exceeded , https://stackoverflow.com/a/3027249
                        window.localStorage.clear();
                    }

                    return false;
                }
            } else {
                return false;
            }
        },

        get: function (key) {
            if (window.localStorage && window.localStorage.getItem) {
                var localStorageItem = window.localStorage.getItem(key);

                if (localStorageItem && B.Util.hasXss(localStorageItem)) {
                    console.error('has xss', localStorageItem, B.Util.sanitize(localStorageItem));
                    return B.Util.sanitize(localStorageItem);
                }

                return localStorageItem;
            } else {
                return false;
            }
        },

        remove: function (key) {
            if (window.localStorage && window.localStorage.removeItem) {
                return window.localStorage.removeItem(key);
            } else {
                return false;
            }
        }
    },

    sessionStorage: {
        isEnable: function () {
            if (window.sessionStorage && window.sessionStorage.getItem) {
                return true;
            } else {
                return false;
            }
        },

        set: function (key, value) {
            if (window.sessionStorage && window.sessionStorage.setItem) {
                try {
                    return window.sessionStorage.setItem(key, value);
                } catch (e) {
                    if (B.Util.isStorageQuotaExceeded(e)) {
                        window.sessionStorage.clear();
                    }

                    return false;
                }
            } else {
                return false;
            }
        },

        get: function (key) {
            if (window.sessionStorage && window.sessionStorage.getItem) {
                return window.sessionStorage.getItem(key);
            } else {
                return false;
            }
        },

        remove: function (key) {
            if (window.sessionStorage && window.sessionStorage.removeItem) {
                return window.sessionStorage.removeItem(key);
            } else {
                return false;
            }
        }
    },

    isStorageQuotaExceeded: function (e) {
        return e instanceof DOMException && (
            e.code === 22 || e.code === 1014
            || e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED')
            && (storage && storage.length !== 0);
    },

    getResetHeightInstance: function (callback) {
        var ResetHeight = function (callbackFunc) {
            this.razyReset = function () {
                if (this.$resetDummy && this.$resetDummy.length > 0) {
                    this.$resetDummy.remove();
                }

                this.$resetDummy = jQuery('<div></div>').appendTo(document.body);
                this.$resetDummy.css({ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, 'z-index': -1 });
                this.razyResetTimer(100, 10);
            };

            this.razyResetTimer = function (interval, cnt) {
                var localCnt = cnt;
                this.resetDummyTimer = setInterval(jQuery.proxy(function () {
                    if (cnt == 0) {
                        this.clearResetTimer();
                    }

                    if (this.$resetDummy && this.$resetDummy.length > 0) {
                        if (callbackFunc) {
                            callbackFunc(this.$resetDummy.height());
                        }
                    }

                    cnt--;
                }, this), interval);
            };

            this.clearResetTimer = function () {
                if (this.resetDummyTimer) {
                    clearTimeout(this.resetDummyTimer);
                    this.resetDummyTimer = null;
                }

                if (this.$resetDummy) {
                    this.$resetDummy.remove();
                    this.$resetDummy = null;
                }
            };
        };


        return new ResetHeight(callback).razyReset();
    },

    mozilaForceKeyup: function ($target) {
        var isIntervalRunning;
        var $target = jQuery($target);

        if (B.UserAgent.isFirefox) {
            isIntervalRunning = null;
            $target.on('keydown', function (e) {
                var forceKeyup = function () {
                    return $target.trigger('keyup');
                };

                if (!isIntervalRunning) {
                    return isIntervalRunning = setInterval(forceKeyup, 100);
                }
            });
            return $target.on('blur', function (e) {
                if (isIntervalRunning) {
                    clearInterval(isIntervalRunning);
                    return isIntervalRunning = null;
                }
            });
        }
    },

    /*
    $elem: jQuery Element 혹은 #id, .className
    callbakc: 타이필할때마다 실행되는 함수
     */
    inputTypingHandler: function ($elem, callback, isTrim) {
        var $elem = jQuery($elem);
        var intervalId = this.mozilaForceKeyup($elem);
        var oldVal;
        var keypressHandler = function (e) {
            var val = e.target.value;

            if (isTrim) {
                val = B.Util.trim(val);
            }

            if (oldVal != val) {
                callback($elem, val);
                oldVal = val;
            }

            window.clearInterval(intervalId);
        };
        $elem.on('keyup', keypressHandler);
    },

    clearLocationHash: function () {
        var uri = window.location.toString();

        if (uri.indexOf('#') > 0) {
            var clean_uri = uri.substring(0, uri.indexOf('#'));

            if ('replaceState' in history) window.history.replaceState({}, document.title, clean_uri);
            else {
                var scrollV;
                var scrollH;
                var loc = window.location;
                scrollV = document.body.scrollTop;
                scrollH = document.body.scrollLeft;

                loc.hash = '';

                document.body.scrollTop = scrollV;
                document.body.scrollLeft = scrollH;
            }
        }
    },

    clearLocationQueryString: function () {
        try {
            history.replaceState({}, document.title, location.pathname);
        } catch (e) {
        }
    },

    removeParameter: function (key, sourceURL) {
        /**
         * https://stackoverflow.com/questions/16941104/remove-a-parameter-to-the-url-with-javascript
         */
        var rtn = sourceURL.split('?')[0];
        var param;
        var params_arr = [];
        var queryString = (sourceURL.indexOf('?') !== -1) ? sourceURL.split('?')[1] : '';

        if (queryString !== '') {
            params_arr = queryString.split('&');

            for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split('=')[0];

                if (param === key) {
                    params_arr.splice(i, 1);
                }
            }

            if (params_arr.length > 0) {
                rtn = rtn + '?' + params_arr.join('&');
            }
        }

        return rtn;
    },

    getSelection: function () {
        var selection = '';

        if (window.getSelection) {
            selection = window.getSelection();
        } else if (document.getSelection) {
            selection = document.getSelection();
        } else {
            selection = document.selection.createRange();
        }

        return selection;
    },

    currentLoopListType: '',
    delayLoop: function (list, fn, loopCount, idx, timeout, type) {
        if (B.Util.currentLoopListType == type) {
            var recursiveFunc = function () {
                fn(list[idx], idx);
                idx++;

                if (--loopCount) {
                    B.Util.delayLoop(list, fn, loopCount, idx, timeout, type);
                }
            };

            if (timeout == 0 || idx == 0) {
                recursiveFunc();
            } else {
                setTimeout(recursiveFunc, timeout);
            }
        }
    },

    stringify: function (object) {
        return JSON.stringify(object, null, 4);
    },

    isPc: function () {
        return !B.Util.isMobile();
    },

    getParams: function (url) {
        var params = {};

        if (url) {
            var paramStartIndex = url.indexOf('?') + 1;

            if (paramStartIndex <= url.length) {
                url = url.substring(paramStartIndex, url.length);
                var paramArr = url.split('&');
                for (var i in paramArr) {
                    var values = paramArr[i];
                    var param = values.split('=');
                    var paramValue = '';

                    if (param.length == 2) {
                        paramValue = decodeURIComponent(param[1]);
                    }

                    params[param[0]] = paramValue;
                }
            }
        }

        return params;
    },

    changeOpenGraph: function () {
        var checkThumb = 'daumcdn.net/thumb/C400x400/?fname=';
        var targetThumbSize = B.UserAgent.isMobile ? 'C200x280' : 'C400x560';
        var _this = this;

        jQuery('.wrap_item.item_type_opengraph').each(function (index, element) {
            var el = jQuery(element);
            var appData = el.data('app');

            if (appData.type == 'opengraph') {
                appData = appData.openGraphData;
                var url = appData.canonicalUrl;
                var image = appData.image;
                var type = _this.isBookstoreUrl(url);
                var inTime = true;

                if (type !== 0) {
                    if (type === -1) {
                        var desc = appData.description;

                        if (desc && desc.match(/^\d{4}-\d{2}-\d{2}:/)) {
                            var dateStr = desc.match(/^\d{4}-\d{2}-\d{2}/)[0];
                            var date = new Date(dateStr);

                            if (date != 'Invalid Date') {
                                date.setHours(0);
                                date.setDate(date.getDate() + 1);

                                if (new Date().getTime() > date.getTime()) {
                                    inTime = false;
                                }
                            }
                        }
                    }

                    el.addClass('opengraph_book');

                    if (inTime) {
                        el.find('.inner_wrap_text').append(jQuery('<span class="buy_btn">구매하기</span>'));
                    } else {
                        el.find('.inner_wrap_text').append(jQuery('<span class="buy_btn buy_end_btn">구매마감</span>'));
                    }

                    var StrIndex = image.indexOf(checkThumb);

                    if (StrIndex != -1) {
                        var originalImageUrl = image.substring(StrIndex + checkThumb.length);
                        var changeImage = B.Util.thumbnail(originalImageUrl, targetThumbSize);
                        el.find('.inner_wrap_og_image').css('background-image', 'url(' + changeImage + ')');
                    }

                    el.find('.inner_wrap').attr('data-ctr-expose', 'book_opengraph');
                    el.find('.inner_wrap').attr('data-ctr-click', 'book_opengraph_click');
                } else {
                    el.find('.inner_wrap').attr('data-ctr-expose', 'opengraph');
                    el.find('.inner_wrap').attr('data-ctr-click', 'opengraph_click');
                }
            }
        });
    },

    /**
     *
     * @param url
     * @returns {Number} 0 : ignore, -1 : funding, 1 : book
     */
    isBookstoreUrl: function (url) {
        var regEx = [
            /https?:\/\/storyfunding\.kakao\.com\/support\/\d+\/step1/,
            /https?:\/\/www\.kyobobook\.co\.kr\/redi_book\.jsp\?b=\d+/, // 교보
            /https?:\/\/www\.yes24\.com\/24\/goods\/\d+/, // yes24
            /https?:\/\/www\.yes24\.com\/Product\/Goods\/\d+/, // yes24
            /https?:\/\/www\.aladin\.co\.kr\/shop\/wproduct\.aspx\?ItemId=\d+/, // 알라딘
            /https?:\/\/ridibooks\.com\/v2\/Detail\?id=\d+/, // 리디북스
            /https?:\/\/book\.interpark\.com\/product\/BookDisplay\.do\?_method=detail.*&sc\.prdNo=\d+/, // 인터파크
            /https?:\/\/brunch\.co\.kr\/publish\/book\/\d+/ // 브런치북
        ];
        var len = regEx.length;
        for (var i = 0; i < len; i++) {
            if (regEx[i].test(url)) {
                return i == 0 ? -1 : 1;
            }
        }
        return 0;
    },

    convertReadSeconds: function (readSecond) {
        if (readSecond < 60) {
            return 1;
        } else {
            return Math.round(readSecond / 60);
        }
    },

    thumbnail: function (imageUrl, format) {
        if (!imageUrl) {
            return '';
        }

        var thumbnailDomain = 'img1.daumcdn.net';

        if (imageUrl.indexOf('sandbox.kakaocdn.net') >= 0) {
            thumbnailDomain = 'img1-sandbox.kakaocdn.net';
        }

        return B.Util.internalThumbnail(thumbnailDomain, imageUrl, format);
    },

    internalThumbnail: function (thumbnailDomain, imageUrl, format) {
        if (!imageUrl) {
            return '';
        }

        return '//' + thumbnailDomain
            + '/thumb/'
            + format
            + B.Util.getTenth2FrameName(imageUrl)
            + '/?fname='
            + imageUrl;
    },

    getTenth2FrameName: function (originalImageUrl) {
        var allowedImages = ['jpg', 'png', 'gif'];
        for (var i = 0; i < allowedImages.length; i++) {
            var lastElement = originalImageUrl.split('.').pop();

            if (lastElement === allowedImages[i]) {
                return '.f' + allowedImages[i];
            }
        }
        return '.fjpg';
    },

    removeCommas: function (text) {
        return text.replace(/,/g, '');
    },

    numberWithCommas: function numberWithCommas (text) {
        return text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    byteSize: function (c) {
        if (c <= 0x00007F) {
            return 1;
        } else if (c <= 0x0007FF) {
            return 2;
        } else if (c <= 0x00FFFF) {
            return 3;
        } else {
            return 4;
        }
    },

    byteLength: function (str) {
        var byteLen = 0;
        for (var i = 0; i < str.length; i++) {
            byteLen = byteLen + this.byteSize(str.charCodeAt(i));
        }
        return byteLen;
    },

    cutByteLength: function (str, len) {
        if (str == null || str.length == 0) {
            return;
        }

        var size = 0;
        var idx = str.length;

        for (var i = 0; i < str.length; i++) {
            size += this.byteSize(str.charCodeAt(i));

            if (size == len) {
                idx = i + 1;
                break;
            } else if (size > len) {
                idx = i;
                break;
            }
        }

        return str.substring(0, idx);
    },

    appendDownloadParam: function (url) {
        if (!url || /(\?download|&download)/.test(url)) {
            return url;
        } else {
            if (url.indexOf('?') !== -1) {
                return url + '&download';
            } else {
                return url + '?download';
            }
        }
    },

    isValidEmail: function (email) {
        var EMAIL_REGEXP = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

        return EMAIL_REGEXP.test(email);
    },

    sanitize: function (text) {
        try {
            if (DOMPurify) {
                return DOMPurify.sanitize(text);
            }
        } catch (e) {
            console.error('DOMPurify does not exist.');
        }

        return text;
    },

    hasXss: function (text) {
        if (this.sanitize) {
            return this.sanitize(text).length !== text.length;
        }

        return false;
    },

    escapeSpecialChar: function (text) {
        return text.replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
            .replace(/\//g, '&#47;')
            .replace(/\\/g, '//');
    },

    unEscapeSpecialChar: function (text) {
        return text.replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/&#47;/g, '\/');
    },

    /**
     * Matrix Custom Error 전송
     * @param error catched Error
     * @param {{message: string, tag: {name: string, value: string}, error: Object}} debugInfo 에러 디버깅 정보
     */
    sentryLogging: function (error, debugInfo) {
        Sentry.addBreadcrumb({
            type: 'error',
            category: 'error',
            level: 'error',
            data: debugInfo.error
        });
        Sentry.setTag(debugInfo.tag.name, debugInfo.tag.value);
        Sentry.captureMessage(debugInfo.message);
    },

    /**
     * 정수 혹은 실수 값을 받아서 실수 인 경우 floor한 값을 반환 한다.
     * @param {number} number 정수 혹은 실수의 값
     * @returns {number}
     */
    getIntegerNumber: function (number) {
        if (number % 1 === 0) {
            return number;
        }

        return Math.floor(number);
    }
};

Handlebars.registerHelper('thumbnail', function (imageUrl, format) {
    return B.Util.thumbnail(imageUrl, format);
});

(function ($) {
    $.fn.getCurrentCount = function () {
        var countText = $(this).text();
        countText = B.Util.removeCommas(countText);
        return Number(countText);
    };

    $.fn.processCount = function (increase) {
        var count = $(this).getCurrentCount();

        if (increase) {
            count++;
        } else {
            // 언라이킷버튼 클릭 시 -1 표기 되는 현상 방지.
            if (count > 0) {
                count--;
            }
        }

        var countText = B.Util.numberWithCommas(count);

        if (count === 0) {
            countText = '';
        }

        $(this).text(countText);
    };
})(jQuery);

